import {
	submitEvent,
	submitMerge,
	submitMiniAction,
	submitMove,
	trackOnNextPageImpression
} from "@otto-ec/tracking-bct";

function buildAttributionMovePayload(combolist, clickedCombo) {
	const pageCluster = window.o_util.misc.getPagecluster();
	return {
		"wk.promo_AttributionFeature": `${combolist.promoType}_${pageCluster}`,
		"wk.promo_AttributionSource": clickedCombo.contentSource ? clickedCombo.contentSource : "ComboListDetail"
	};
}

export function sendLoadTrackingEvent(combolist, currentSlides) {
	const combolistPayload = combolist.getTrackingPayload("loaded");

	const visibleCombos = combolist.combos.filter(combo => currentSlides.includes(combo.position - 1));
	const combosPayload = visibleCombos.flatMap(combo => {
		const comboTrackingPayload = combo.getLoadTrackingPayloadForParent(combolistPayload.id);
		const articlesTrackingPayload = combo.articles.map(article => {
			return article.getLoadTrackingPayloadForParentAndStatus(comboTrackingPayload.id);
		});
		return [comboTrackingPayload, ...articlesTrackingPayload];
	});

	submitMerge({}, [combolistPayload, ...combosPayload]);
}

export function sendComboClickTrackingEvent(combolist, clickedCombo) {
	function buildComboPayload() {
		const combolistClickTrackingPayload = combolist.getTrackingPayload("clicked");
		return {
			name: "click",
			features: [
				combolistClickTrackingPayload,
				clickedCombo.getClickTrackingPayloadForParent(combolistClickTrackingPayload.id)
			]
		};
	}

	submitMove(buildAttributionMovePayload(combolist, clickedCombo), buildComboPayload());
	trackOnNextPageImpression({ promo_Click: combolist.promoType });
}

export function sendComboOpenTrackingEvent(combolist, clickedCombo) {
	function buildComboEventPayload() {
		const pageCluster = window.o_util.misc.getPagecluster();
		return {
			ot_MessageType: "event",
			"wk.promo_AttributionFeature": `${combolist.promoType}_${pageCluster}`,
			"wk.promo_AttributionSource": clickedCombo.contentSource ? clickedCombo.contentSource : "ComboListDetail"
		};
	}

	function buildComboPayload() {
		const combolistClickTrackingPayload = combolist.getTrackingPayload("clicked");
		return {
			name: "open",
			features: [
				combolistClickTrackingPayload,
				clickedCombo.getClickTrackingPayloadForParent(combolistClickTrackingPayload.id)
			]
		};
	}

	submitEvent(buildComboEventPayload(), buildComboPayload());
	trackOnNextPageImpression({ promo_Click: combolist.promoType });
}

export function sendArticleClickTrackingEvent(combolist, clickedCombo, clickedArticle) {
	function buildArticlePayload() {
		const combolistWidgetClickTrackingPayload = combolist.getTrackingPayload("clicked");
		const widgetParentId = combolistWidgetClickTrackingPayload.id;
		const combolistComboClickTrackingPayload = clickedCombo.getClickTrackingPayloadForParent(widgetParentId);
		const comboParentId = combolistComboClickTrackingPayload.id;
		const combolistArticlesClickTrackingPayload =
			clickedArticle.getClickTrackingPayloadForParentAndStatus(comboParentId);

		return {
			name: "click",
			features: [
				combolistWidgetClickTrackingPayload,
				combolistComboClickTrackingPayload,
				combolistArticlesClickTrackingPayload
			]
		};
	}

	submitMove(buildAttributionMovePayload(combolist, clickedCombo), buildArticlePayload());

	trackOnNextPageImpression({ promo_Click: combolist.promoType });
}

export function sendScrollRightOrLeftTrackingEvent(combolist, featureOrder, positions, action) {
	const combolistPayload = combolist.getTrackingPayload("visible");
	const combosPayload = [];

	if (combolist.combos) {
		for (const position of positions) {
			if (combolist.combos[position]) {
				const currentVisibleCombo = combolist.combos[position];

				const comboTrackingPayload = currentVisibleCombo.getVisibleTrackingPayloadForParent(
					combolistPayload.id
				);
				const articlesTrackingPayload = currentVisibleCombo.articles.map(article => {
					return article.getVisibleTrackingPayloadForParentAndStatus(comboTrackingPayload.id);
				});
				combosPayload.push(comboTrackingPayload, ...articlesTrackingPayload);
			}
		}
	}
	const payload = {
		name: action,
		features: [combolistPayload, ...combosPayload]
	};

	submitEvent({}, payload);
}

export function sendVisibleTrackingEvent(combolist) {
	const visibleCombos = combolist.combos.filter(combo => combo.isVisible === true);

	const combolistPayload = combolist.getFeatureIdPayload();
	const combosPayload = visibleCombos.flatMap(combo => {
		const comboTrackingPayload = combo.getFeatureIdPayloadForParent(combolistPayload.featureId);
		const articlesTrackingPayload = combo.articles.map(article => {
			return article.getFeatureIdPayloadForParent(comboTrackingPayload.featureId);
		});
		return [comboTrackingPayload, ...articlesTrackingPayload];
	});
	submitMiniAction([combolistPayload, ...combosPayload]);
}
